import { spiritoryWebApi } from '@/lib/axios/spiritoryWebApi';

export default async function doSendPasswordReset(
  email: string,
  captcha: string
) {
  try {
    await spiritoryWebApi.post(
      '/auth/reset-password/send',
      { email, captcha },
      undefined
    );
  } catch (err) {
    throw err;
  }
}
